export const AVAILABLE_TARGET_LOCATION = {
  'johor-bahru': 'Johor Bahru, MY'
} as const;
